export const langFormatter = ({ lang }) => {
  if (lang === 'az') {
    return 'AZE';
  }
  if (lang === 'ru') {
    return 'RU';
  }
  if (lang === 'en') {
    return 'ENG';
  }
};
